import { call, put, all, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
    FETCH_SYSTEM_PREFERENCE_WITH_OPTIONS,
    RECEIVE_SYSTEM_PREFERENCE,
    FETCH_SYSTEM_MESSAGE,
    FETCH_SYSTEM_PREFERENCE,
    REQUEST_SYSTEM_PREFERENCE,
    FETCH_SYSTEM_STATUS
} from '../actions/ActionTypes';
import {
    receiveSystemMessage,
    receiveSystemPreference,
    requestSystemPreference,
    receiveSystemStatus
} from '../actions';

//workers
export function* fetchSystemPreferenceWithOptions(action) {
    //TODO: Replace call with put inside yield all CA-37079
    try {
        const { preferenceKey, nextActions, truthTestFunc } = action;
        const response = yield call(axios.get, `/preference/${preferenceKey}`, { baseURL: '/modern' });

        yield put({
            type: RECEIVE_SYSTEM_PREFERENCE,
            key: preferenceKey,
            preference: response.data,
            receivedAt: Date.now()
        });

        if (nextActions && truthTestFunc && truthTestFunc(response.data.value)) {
            yield all(nextActions.map((action) => call(action.type, action)));
        }
    } catch (e) {}
}

export function* fetchSystemMessage() {
    try {
        const response = yield call(axios.get, `/system-service/preference/SystemPreferenceDisplay.systemMessage`, {
            baseURL: '/modern',
            timeout: axios.defaults.timeout,
            headers: axios.defaults.headers.common
        });

        yield put(receiveSystemMessage(response.data));
    } catch (e) {}
}

export function* fetchSystemPreferenceSaga({ key }) {
    try {
        yield put(requestSystemPreference(REQUEST_SYSTEM_PREFERENCE));
        const response = yield axios.get(`/preference/${key}`, { baseURL: '/modern' });
        yield put(receiveSystemPreference(RECEIVE_SYSTEM_PREFERENCE, key, response.data));
    } catch (e) {}
}

export function* fetchSystemStatus() {
    try {
        const response = yield call(axios.get, `/site-status/garmin-connect-status.json`, {
            baseURL: '/',
            timeout: axios.defaults.timeout,
            headers: axios.defaults.headers.common
        });

        yield put(receiveSystemStatus(response.data));
    } catch (e) {}
}

//watchers
export const systemSagas = [
    takeEvery(FETCH_SYSTEM_PREFERENCE_WITH_OPTIONS, fetchSystemPreferenceWithOptions),
    takeEvery(FETCH_SYSTEM_MESSAGE, fetchSystemMessage),
    takeEvery(FETCH_SYSTEM_PREFERENCE, fetchSystemPreferenceSaga),
    takeEvery(FETCH_SYSTEM_STATUS, fetchSystemStatus)
];
